module.exports = __webpack_public_path__ + "media/reportAssets/process-cace6c98.png";